import React from 'react';
import Editor from '../../components/BrainPocket/Editor';
import Sidebar from '../../components/BrainPocket/Sidebar';
import TopBar from '../../components/BrainPocket/TopBar';
import { useBrainPocket } from '../../hooks/useBrainPocket';
import './BrainPocket.css';

function BrainPocket() {
  const brainPocket = useBrainPocket();

  return (
    <section className="brainpocket-page" aria-label="BrainPocket article archiver">
      <TopBar
        store={brainPocket.store}
        totals={brainPocket.totals}
        importBackup={brainPocket.importBackup}
        importError={brainPocket.importError}
      />
      <div className="brainpocket-workspace">
        <Sidebar
          search={brainPocket.search}
          setSearch={brainPocket.setSearch}
          filteredDomains={brainPocket.filteredDomains}
          domainOpen={brainPocket.domainOpen}
          setDomainOpen={brainPocket.setDomainOpen}
          selectedArticleId={brainPocket.selectedArticleId}
          setSelectedArticleId={brainPocket.setSelectedArticleId}
        />
        <Editor
          addArticle={brainPocket.addArticle}
          selectedArticle={brainPocket.selectedArticle}
          toggleRead={brainPocket.toggleRead}
          addKeyPoint={brainPocket.addKeyPoint}
          deleteKeyPoint={brainPocket.deleteKeyPoint}
          deleteArticle={brainPocket.deleteArticle}
          totals={brainPocket.totals}
        />
      </div>
    </section>
  );
}

export default BrainPocket;
